let userPermission = {};

let gobaleUser = {};

let tenantsContext = {};

let hasRefreshedToken = false;

let v2 = []

let v3 = []

let robot_status = {}
let robot_status_config = {}

let robot_family = []

export function useUser() {
  const setUser = (u) => {
    gobaleUser = u;
  };
  const user = _.cloneDeep(gobaleUser);
  return [user, setUser];
}

export function usePermission() {
  const setPermission = (permission) => {
    userPermission = permission;
  };
  const permission = _.cloneDeep(userPermission);
  return [permission, setPermission];
}

export function setPermissionCodeList(permission) {
  userPermission = permission;
}

export function getUserPermission() {
  return userPermission;
}

export function useTenantsContext() {
  const setTenants = (tc) => {
    tenantsContext = tc;
  };
  const tenants = _.cloneDeep(tenantsContext);
  return [tenants, setTenants];
}

export function useHasRefreshedToken() {
  const setHasRefreshedToken = (u) => {
    hasRefreshedToken = u;
  };
  return [hasRefreshedToken, setHasRefreshedToken];
}

export function useMaintenanceRegionsV2() {
  const setMaintenanceRegionsV2 = (u) => {
    v2 = u;
  };
  const maintenanceRegionsV2 = _.cloneDeep(v2);
  return [maintenanceRegionsV2, setMaintenanceRegionsV2];
}

export function useMaintenanceRegionsV3() {
  const setMaintenanceRegionsV3 = (u) => {
    v3 = u;
  };
  const maintenanceRegionsV3 = _.cloneDeep(v3);
  return [maintenanceRegionsV3, setMaintenanceRegionsV3];
}

export function useRobotStatus() {
  const setRobotStatus = (u) => {
    console.log("robot_status", u);
    robot_status = u;
  };
  const robotStatus = _.cloneDeep(robot_status);
  return [robotStatus, setRobotStatus];
}

export function useRobotStatusConfig() {
  const setRobotStatusConfig = (u) => {
    robot_status_config = u;
  };
  const robotStatusConfig = _.cloneDeep(robot_status_config);
  return [robotStatusConfig, setRobotStatusConfig];
}

export function useRobotFamily() {
  const setRobotFamily = (u) => {
    robot_family = u;
  };
  const robotFamily = _.cloneDeep(robot_family);
  return [robotFamily, setRobotFamily];
}